<template>
  <div class="layout">
    <vue-progress-bar/>
    <div class="layout__navbar">
      <div class="navbar__logo">
        <img src="/static/controles_contra.png" alt="Logo" class="img-responsive">
        <router-link :to="{ name: 'perfil' }" tag="p"
                     class="navbar__user" active-class="navbar__user--active">
          <i class="far fa-fw fa-user-circle text--blanco"/>
          <span class="text text--blanco">{{ $auth.credenciales.cliente.nombre }}</span>
        </router-link>
      </div>
      <div class="navbar__content">
        <filtro-notas ref="filtroNotas"/>
      </div>
    </div>
    <div class="layout__navbar__tabs">
      <div class="tabs">
        <router-link :to="{ name: 'grafos' }" tag="div"
                     class="tabs__tab" active-class="tabs__tab--active">
          <p>
            <i class="far fa-fw fa-chart-pie"/>
            <span class="text">Gráficos</span>
          </p>
        </router-link>
        <router-link :to="{ name: 'notas' }" tag="div"
                     class="tabs__tab" active-class="tabs__tab--active">
          <p>
            <i class="far fa-fw fa-file-alt"/>
            <span class="text">Notas</span>
          </p>
        </router-link>
      </div>
    </div>
    <div class="layout__content">
      <div class="layout__padding">
        <router-view/>
      </div>
    </div>
    <div class="layout__footer">
      Desarrollado por <a href="https://www.ciriscr.com" target="_blank">
        <img src="/static/pajaro.png" alt="Icono Ciris"
             class="img--responsive" style="height: 14px;">
        Ciris Informatic Solutions
      </a>
      <p>Controles feedperception Zense © | 2018</p>
      <p class="navbar__user__version text--gris6 text text--small text--center text--italic">
        Versión: {{ version }}
      </p>
    </div>
  </div>
</template>

<script>
import FiltroNotas from "./notas/FiltroNotas.vue";
import pkg from "../../package.json";

function data() {
  return {
    estaMostrado: false,
  };
}

function created() {
  this.$on("mostrarMenu", () => {
    this.estaMostrado = !this.estaMostrado;
  });
}

export default {
  name: "App",
  components: {
    FiltroNotas,
  },
  data,
  computed: {
    version,
  },
  created,
};

function version() {
  return pkg.version;
}

</script>

<style lang="scss">
  @import "../sass/base/colores";
  @import "../sass/tema/colores";
  @import "../sass/base/helpers";
  @import "../sass/tema/globales";

  $nav-margin: 80px;

  .layout__content{
    min-height: 100vh;
    padding-top: $nav-margin + 16px;
    width: 100%;
    position: relative;
  }

  .layout__navbar{
    @extend .sombra;
    background: $negro2;
    position: fixed;
    width: 100%;
    height: $nav-margin;
    top: 0;
    left: 0;
    z-index: 4;
    display: flex;
  }

  .navbar__logo{
    width: 66%;
    padding: 0 .5em;
    img{
      height: 50px;
      margin: 0 auto;
    }
  }

  .navbar__content{
    width: 85%;
    flex-grow: 2;
  }

  .layout__navbar__tabs{
    @extend .sombra;
    background: $negro2;
    border: 2px solid $negro2;
    border-top: 0;
    position: fixed;
    top: $nav-margin;
    overflow: hidden;
    width: 200px;
    right: 0;
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
    z-index: 3;
  }

  .layout__padding {
    padding: 1em;
    height: 100%;
    @media (min-width: $reflex-md ) {
      padding: 1em 3em;
    }
  }

  .layout__footer{
    font-size: 80%;
    text-align: center;
    color: $gris6;

    a {
      text-decoration: none;
      color: $rojo-opaco;
    }
  }

  .botones-pagina{
    text-align: center;
  }

  .navbar__user{
    cursor: pointer;
    &:hover{
      color: $rojo;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Home.vue